import { Dropdown, IconButton, SvgMoreHoriz, Tooltip } from '@loomhq/lens';
import React from 'react';

import { COPY_LINK } from 'constants/menuOptions';

import useShareMenuOptions from 'hooks/useShareMenuOptions';

import HideDuringDowntime from 'components/hide-during-downtime';

const OverflowMenu = ({ video, isLoggedIn }) => {
  // TODO: Refactor this to use useBulkMenuOptions once this does not depend on a videos dashboard context
  const options = useShareMenuOptions({ video });

  if (!options?.length) {
    return null;
  }

  if (options.length === 1) {
    const { title, icon, onClick, disabled } = options[0];

    if (title === COPY_LINK) {
      return null;
    }

    return (
      <IconButton
        altText={title}
        icon={icon}
        onClick={onClick}
        isDisabled={disabled}
      />
    );
  }

  return (
    <HideDuringDowntime>
      <Dropdown
        options={options}
        trigger={
          <Tooltip content="More actions..." placement="bottomLeft">
            <IconButton altText="Toggle actions" icon={<SvgMoreHoriz />} />
          </Tooltip>
        }
        menuPosition="right"
        menuZIndex={isLoggedIn ? 100 : 1001}
      />
    </HideDuringDowntime>
  );
};

export default OverflowMenu;
